import React, { useState, useRef } from 'react';
import json2csv from 'json2csv';
import FileSaver from 'file-saver';
// import { Button } from "@mui/material";
import TransferList from './TransferList'; // Importa el componente TransferList desde tu ruta correcta
import {
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  TextField,
  LinearProgress,
  CircularProgress,
  Typography,
  Divider,
  Alert,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Tabs,
  Tab,
  Box,
  Button,
} from '@mui/material';
import Grid from '@mui/material/Grid';
import { Buttons } from './Buttons';
import { SnackbarMessenger } from './SnackbarMessenger';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import imagen from "src/assets/img/dlys.jpeg";
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import esArray from './functionEsArray';

const flattenJSON = (data, fields, reportTitle, armadoPor) => {
  function ordenarPorTipoMetadato(array) {
    return array.sort((a, b) => {
      const orden = {
        'texto': 0,
        'fecha_desde': 1,
        'fecha_hasta': 2,
        'numero_desde': 3,
        'numero_hasta': 4
      };
      return orden[a.metadato_label_grilla] - orden[b.metadato_label_grilla];
    });
  }

  function ordenarPorLote(arr) {
    return arr.sort((a, b) => a.lote - b.lote);
  }

  const existingFieldContenido = fields.indexOf("Tipo de contenido");
  const existingFieldMetadato = fields.indexOf("Metadatos");
  const flattenData = [];

  const esArray = (value) => (Array.isArray(value) ? value : [value]);

  var flattenTitle = {
    Titulo: reportTitle,
    Armado_por: armadoPor,

  };
  flattenData.push(flattenTitle);
  esArray(data).forEach((cuenta) => {
    // const cliente = cuenta.detalle;
    const sectores = cuenta.sectores.sector;
    esArray(sectores).forEach((sector) => {
      const cajas = sector.cajas.caja;
      const sectorDetalle = sector.detalle;
      // const cliente = cuenta.detalle;
      esArray(cajas).forEach((caja) => {
        const { id, estado, ubicacion, contenidos, referencia, id_tipo_caja } = caja;
        const cliente = caja.cliente;
        let referenciaValidado = referencia;
        if (typeof referencia === 'object') {
          referenciaValidado = ""; // Asigna un valor vacío si es un objeto
        }
        const ubicacionValidado = ubicacion ?? "Sin ubicación";
        var flattenContenido = {
          'Cliente': cliente,
          'Sector': sectorDetalle,
          'ID caja': id,
          'Referencia/Nro Anterior': referenciaValidado,
          'Tipo de caja(id)': id_tipo_caja,
          'Ubicacion': ubicacionValidado,
          caja_estado: estado,
        };
        if (contenidos && existingFieldContenido !== -1) {
          const flattenContenidoOriginal = flattenContenido;
          ordenarPorLote(esArray(contenidos)).forEach((contenido) => {
            flattenContenido = {
              ...flattenContenidoOriginal,
              'ID contenido': contenido.id,
              'Lote': contenido.lote,
              contenido_estado: contenido.estado,
              'Tipo de contenido': contenido.detalle_tipo_contenidos,
              ...contenido,
            };

            if (contenido.contenidos_metadatos && existingFieldMetadato !== -1) {
              let metadatosAñadidos = [];
              const metadatosOrdenados = ordenarPorTipoMetadato(esArray(contenido.contenidos_metadatos))
              metadatosOrdenados.forEach((metadato) => {

                const { metadato_label_grilla, metadato_valor, metadato_label_form } = metadato;

                flattenContenido = {
                  ...flattenContenidoOriginal,
                  'ID contenido': contenido.id,
                  'Lote': contenido.lote,
                  contenido_estado: contenido.estado,
                  'Tipo de contenido': contenido.detalle_tipo_contenidos,
                  ...contenido,
                };

                const existingFieldIndex = fields.indexOf(metadato_label_grilla);
                if (existingFieldIndex !== -1) {
                  flattenContenido[metadato_label_grilla] = metadato_valor;
                } else {
                  fields.push(metadato_label_grilla);
                  flattenContenido[metadato.metadato_label_grilla] = metadato.metadato_valor;
                }
                flattenContenido['Metadatos'] = metadato_label_form;
                metadatosAñadidos.push(metadato_label_grilla);
                flattenData.push(flattenContenido);
              })


            } else {
              flattenData.push(flattenContenido);
            }
          })
        } else {
          flattenData.push(flattenContenido);
        };

      });
    });
  });
  return flattenData;
};


const flattenJSONSinJerarquia = (data, fields, reportTitle, armadoPor) => {


  function ordenarPorTipoMetadato(array) {
    return array.sort((a, b) => {
      const orden = {
        'texto': 0,
        'fecha_desde': 1,
        'fecha_hasta': 2,
        'numero_desde': 3,
        'numero_hasta': 4
      };
      return orden[a.label_grilla] - orden[b.label_grilla];
    });
  }

  function ordenarPorLote(arr) {
    return arr.sort((a, b) => a.lote - b.lote);
  }

  const existingFieldMetadato = fields.indexOf("Metadatos");
  const flattenData = [];

  const esArray = (value) => (Array.isArray(value) ? value : [value]);

  // Agrega el título y la información de quién armó el reporte
  flattenData.push({
    Titulo: reportTitle,
    Armado_por: armadoPor,
  });

  ordenarPorLote(esArray(Object.values(data))).forEach((item) => {
    const { cliente, sector, id_caja, referencia, id_contenidos, lote, tipo_contenidos, contenidos_metadatos, id_tipo_cajas, ubicacion, id
    } = item;

    let referenciaValidada = (typeof referencia === 'object' && Object.keys(referencia).length === 0) ? "Sin referencia" : referencia;

    let flattenItem = {
      'Cliente': cliente,
      'Sector': sector,
      'ID caja': id_caja || id,
      'Referencia/Nro Anterior': referenciaValidada,
      'ID contenido': id_contenidos,
      'Lote': lote,
      'Tipo de contenido': tipo_contenidos,
      'Tipo de caja(id)': id_tipo_cajas,
      'Ubicacion': ubicacion,
    };
    const isNonEmptyObject = (v) =>
      v && typeof v === 'object' && !Array.isArray(v) && Object.keys(v).length > 0;

    if (contenidos_metadatos && isNonEmptyObject(contenidos_metadatos) && existingFieldMetadato !== -1) {
      console.log("contenidos_metadatos", contenidos_metadatos);
      let metadatosAñadidos = [];
      const metadatosOrdenados = ordenarPorTipoMetadato(esArray(contenidos_metadatos.metadato));
      console.log("metadatosOrdenados", metadatosOrdenados);
      metadatosOrdenados.forEach((metadato) => {
        const { label_grilla, valor, label_form } = metadato;

        // Crear una copia nueva de flattenItem para cada iteración
        let nuevoFlattenItem = { ...flattenItem };

        // Agrega metadatos a la estructura
        const existingFieldIndex = fields.indexOf(label_grilla);
        if (existingFieldIndex !== -1) {
          nuevoFlattenItem[label_grilla] = valor;
        } else {
          fields.push(label_grilla);
          nuevoFlattenItem[label_grilla] = valor;
        }
        metadatosAñadidos.push(label_grilla);
        nuevoFlattenItem['Metadatos'] = label_form; // Ahora cada objeto tendrá su propio 'Metadatos'
        flattenData.push(nuevoFlattenItem);
      });


    } else {
      flattenData.push(flattenItem);
    }

  });

  return flattenData;
};

const obtenerFechaConFormato = () => {
  const fechaActual = new Date();
  const dia = String(fechaActual.getDate()).padStart(2, '0');
  const mes = String(fechaActual.getMonth() + 1).padStart(2, '0');
  const año = fechaActual.getFullYear();

  return `${dia}/${mes}/${año}`;
};

const getDynamicColumns = (data) => {

  const uniqueColumns = new Set();

  const esArray = (value) => (Array.isArray(value) ? value : [value]);

  esArray(data).forEach((item) => {
    esArray(item.sectores.sector).forEach((sector) => {
      const { cajas } = sector;

      esArray(cajas.caja).forEach((caja) => {
        if (caja.contenidos) {
          esArray(caja.contenidos).forEach((contenido) => {
            if (contenido.contenidos_metadatos) {
              esArray(contenido.contenidos_metadatos).forEach((metadato) => {
                if (metadato?.metadato_label_grilla) {
                  uniqueColumns.add(metadato.metadato_label_grilla);
                }

              });
            }

          });
        }

      });
    });
  });

  return Array.from(uniqueColumns);
};

const getDynamicColumnsSinJerarquia = (data) => {

  const uniqueColumns = new Set();

  const esArray = (value) => (Array.isArray(value) ? value : [value]);

  esArray(data).forEach((item) => {
    if (item.contenidos_metadatos) {
      esArray(item.contenidos_metadatos).forEach((metadato) => {
        if (metadato?.metadato_label_grilla) {
          uniqueColumns.add(metadato.metadato_label_grilla);
        }

      });
    }
  });

  return Array.from(uniqueColumns);
};


const ROWS_PER_SEC = { Excel: 16342, CSV: 25000, JSON: 22000 };

const ButtonsExportJsonCSV = (props) => {
  const { totalPages, limit, idElementData, data, exportarCajasContenidosColumns = false, getAllData = null, getExportCount = null, getCajasSinContenidos = null } = props.props;
  let usuarioValues = JSON.parse(
    localStorage.getItem("siam-user-data")
  )
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [fileType, setFileType] = useState('CSV');
  const [reportTitle, setReportTitle] = useState('');
  const [armadoPor, setArmadoPor] = useState(usuarioValues.username || '');
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [snackbarVisible, setSnackbarVisible] = useState(false);
  const [mergeCells, setMergeCells] = useState(true);
  const [isExporting, setIsExporting] = useState(false);
  const [exportProgress, setExportProgress] = useState(null); // { current, total, startTime }
  const [countdown, setCountdown] = useState(null);           // seconds remaining
  const [countdownTotal, setCountdownTotal] = useState(null); // original seconds (for progress bar)
  const countdownIntervalRef = useRef(null);
  const [activeTab, setActiveTab] = useState(0);
  const [marcarSinContenidos, setMarcarSinContenidos] = useState(false);
  const [agruparSinContenidos, setAgruparSinContenidos] = useState('');
  const [analisisData, setAnalisisData] = useState(null);
  const [analisisTotales, setAnalisisTotales] = useState(null);
  const [analisisLoading, setAnalisisLoading] = useState(false);
  const [analisisError, setAnalisisError] = useState(null);

  function mergeData(unified, newData) {
    esArray(newData.cuenta).forEach(cliente => {
      // buscar cliente existente
      let existingCliente = unified.find(c => c.id === cliente.id);

      if (!existingCliente) {
        // si no existe el cliente, lo agregamos normalizando sectores a array
        unified.push({
          ...cliente,
          sectores: {
            sector: Array.isArray(cliente.sectores?.sector)
              ? [...cliente.sectores.sector]
              : cliente.sectores?.sector
                ? [cliente.sectores.sector]
                : []
          }
        });
      } else {
        // si el cliente ya existe, mergeamos sectores
        const nuevosSectores = Array.isArray(cliente.sectores?.sector)
          ? cliente.sectores.sector
          : cliente.sectores?.sector
            ? [cliente.sectores.sector]
            : [];

        nuevosSectores.forEach(sector => {
          let existenteSector = esArray(existingCliente.sectores.sector).find(
            s => s.id === sector.id
          );

          if (!existenteSector) {
            esArray(existingCliente.sectores.sector).push(sector);
          } else {
            // mergear cajas dentro del sector
            const nuevasCajas = Array.isArray(sector.cajas?.caja)
              ? sector.cajas.caja
              : sector.cajas?.caja
                ? [sector.cajas.caja]
                : [];

            nuevasCajas.forEach(caja => {
              const existeCaja = esArray(existenteSector.cajas.caja).find(
                c => c.id === caja.id
              );
              if (!existeCaja) {
                esArray(existenteSector.cajas.caja).push(caja);
              }
            });
          }
        });
      }
    });

    return unified;
  }


  const getEtaText = () => {
    if (!exportProgress || exportProgress.current === 0 || exportProgress.total <= 1) return '';
    const elapsed = Date.now() - exportProgress.startTime;
    const perPage = elapsed / exportProgress.current;
    const remaining = (exportProgress.total - exportProgress.current) * perPage;
    const seconds = Math.ceil(remaining / 1000);
    return seconds > 0 ? `~${seconds}s restantes` : '';
  };

  const obtenerJsonReporte = async (onProgress) => {
    let mergedObj = []
    let mergedArray = [];
    let sin_jerarquia = false;
    let response
    for (var i = 0; i < totalPages; i++) {
      let offsetReporte = limit * i;
      if (idElementData !== undefined) {
        const isRequiredContenido = selectedColumns.includes("Tipo de contenido");
        let dataBusqueda;
        if (isRequiredContenido) {
          dataBusqueda = { ...idElementData, devuelveContenidos: "1", exportarCajasContenidos: "1", soloCajas: "1", contabilizar_estadisticas: "0" }
        } else {
          dataBusqueda = { ...idElementData, contabilizar_estadisticas: "0" }
        }


        response = await data?.options?.getPaginated(
          limit,
          offsetReporte,
          dataBusqueda
        ); // se trae los records mediante un id de algun tipo de elemento que sea necesario

      } else {
        response = await data?.options?.getPaginated(limit, offsetReporte); //probelma esta cuando el offfsett (limit*page supera la cantidad de registros)
      }

      if (response.response) {
        response = response.response;
      }

      if (response.status === 'true') {

        mergedObj = mergeData(mergedObj, response.reporte);

      } else if (response.data.length > 0) {

        sin_jerarquia = response.sin_jerarquia;
        mergedArray = mergedArray.concat(response.data);
      }

      onProgress?.(i + 1, totalPages);
    }

    const data_return = { sin_jerarquia: sin_jerarquia, data: sin_jerarquia ? mergedArray : { cuenta: mergedObj } }
    return data_return;

  };

  function ordenarArray(originalArray, order) {
    // Crear un nuevo array vacío para almacenar los elementos ordenados
    const newArray = [];

    // Recorrer el orden deseado y agregar los elementos existentes al nuevo array
    for (const element of order) {
      const foundElement = originalArray.find(item => item === element);

      if (foundElement) {
        newArray.push(foundElement);
      }
    }

    // Recorrer el array original y agregar los elementos que no estén en el nuevo array
    for (const element of originalArray) {
      if (!newArray.includes(element)) {
        newArray.push(element);
      }
    }

    return newArray;
  }


  const handleClick = (jsonData, sin_jerarquia = false) => {
    let data = jsonData

    const existingFieldMetadato = selectedColumns.indexOf("Metadatos");

    const ordenDeseado = ['ID caja', 'Cliente', 'Sector', 'Referencia/Nro Anterior', 'Tipo de caja(id)', 'Ubicacion', 'Tipo de contenido', 'ID contenido', 'Lote', 'Metadatos'];
    const arrayOrdenado = ordenarArray(selectedColumns, ordenDeseado);

    const columns = arrayOrdenado;
    const dynamicColumns = existingFieldMetadato !== -1 ? sin_jerarquia ? getDynamicColumnsSinJerarquia(data.cuentas) : getDynamicColumns(data.cuentas.cuenta) : [];
    const ordenDeseadoDynamicColumns = ['texto', 'fecha_desde', 'fecha_hasta', 'numero_desde', 'numero_hasta']
    const dynamicColumnsOrdenados = existingFieldMetadato !== -1 ? ordenarArray(dynamicColumns, ordenDeseadoDynamicColumns) : [];
    // columnas completas
    const fields = [...columns, ...dynamicColumnsOrdenados];
    // datos
    const flattenData = sin_jerarquia ? flattenJSONSinJerarquia(data.cuentas, fields, reportTitle, armadoPor) : flattenJSON(data.cuentas.cuenta, fields, reportTitle, armadoPor);

    // Convierte cada parte a CSV
    const csvDataFirstLine = json2csv.parse(flattenData, { fields: ['Titulo', 'Armado_por'] });
    const csvDataSecondLine = json2csv.parse(flattenData, { fields: fields });


    // Combina las dos líneas
    const csvData = `${csvDataFirstLine}\n\n${csvDataSecondLine}`;

    // const csvData = json2csv.parse(flattenData, { fields });
    const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' });

    const fileName = `export_${usuarioValues.username}_${obtenerFechaConFormato()}.csv`;
    FileSaver.saveAs(blob, fileName);
  };

  const exportToJsonFile = async () => {
    setIsExporting(true);
    try {
      if (getAllData) {
        if (getExportCount) {
          const { count } = await getExportCount(idElementData);
          const seconds = Math.max(1, Math.ceil(count / ROWS_PER_SEC['JSON']));
          setCountdown(seconds);
          setCountdownTotal(seconds);
          countdownIntervalRef.current = setInterval(() => {
            setCountdown(prev => {
              if (prev <= 1) {
                clearInterval(countdownIntervalRef.current);
                countdownIntervalRef.current = null;
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
        }
        try {
          await getAllData(idElementData, 'JSON', { titulo: reportTitle, armado_por: armadoPor });
        } finally {
          if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
          }
          setCountdown(null);
          setCountdownTotal(null);
        }
        return;
      }
      let data = await obtenerJsonReporte();
      const data_array = data.data;
      // Convertir el objeto en formato JSON
      const jsonData = JSON.stringify({ cuentas: data_array });
      // Generar un nombre de archivo único basado en la fecha y hora actual
      const fileName = `export_${usuarioValues.username}_${obtenerFechaConFormato()}.json`;

      // Crear un Blob con el contenido JSON
      const blob = new Blob([jsonData], { type: 'application/json' });

      // Generar la URL del archivo Blob
      const url = URL.createObjectURL(blob);

      // Crear un enlace (<a>) para descargar el archivo
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;

      // Agregar un event listener para ejecutar props.toggleModal() después de la descarga
      link.addEventListener('click', () => {
        props.toggleModal();
        // Limpiar la URL del objeto Blob después de un tiempo para liberar recursos
        setTimeout(() => URL.revokeObjectURL(url), 100);
      });

      // Simular un clic en el enlace
      link.click();
    } catch (error) {
      setMessage(error?.message || "Error al exportar");
      setSeverity("error");
      setSnackbarVisible(true);
    } finally {
      setIsExporting(false);
    }
  };

  function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
  }

  const handleDownload = async () => {
    setIsExporting(true);
    try {
      if (getAllData) {
        if (getExportCount) {
          const { count } = await getExportCount(idElementData);
          const seconds = Math.max(1, Math.ceil(count / ROWS_PER_SEC['CSV']));
          setCountdown(seconds);
          setCountdownTotal(seconds);
          countdownIntervalRef.current = setInterval(() => {
            setCountdown(prev => {
              if (prev <= 1) {
                clearInterval(countdownIntervalRef.current);
                countdownIntervalRef.current = null;
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
        }
        try {
          await getAllData(idElementData, 'CSV', { titulo: reportTitle, armado_por: armadoPor });
        } finally {
          if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
          }
          setCountdown(null);
          setCountdownTotal(null);
        }
        return;
      }
      let jsonReporte = await obtenerJsonReporte();
      const data_array = jsonReporte.data;
      let jsonReporteFinal = { cuentas: data_array };
      if (!isEmptyObject(data_array)) {
        handleClick(jsonReporteFinal, jsonReporte.sin_jerarquia);
      } else {
        setMessage("No se encontraron registros como para armar un reporte");
        setSeverity("warning");
        setSnackbarVisible(true);
      }
    } catch (err) {
      setMessage(err?.message || "Error al exportar");
      setSeverity("error");
      setSnackbarVisible(true);
    } finally {
      setIsExporting(false);
    }
  };


  const handleDownloadExcel = async () => {
    setIsExporting(true);
    try {
      if (getAllData) {
        if (getExportCount) {
          // Pre-flight: obtener cantidad de filas para calcular duración exacta
          const { count } = await getExportCount(idElementData);
          const seconds = Math.max(1, Math.ceil(count / ROWS_PER_SEC['Excel']));
          setCountdown(seconds);
          setCountdownTotal(seconds);
          countdownIntervalRef.current = setInterval(() => {
            setCountdown(prev => {
              if (prev <= 1) {
                clearInterval(countdownIntervalRef.current);
                countdownIntervalRef.current = null;
                return 0;
              }
              return prev - 1;
            });
          }, 1000);
        }
        try {
          await getAllData(idElementData, 'Excel', {
            titulo: reportTitle,
            armado_por: armadoPor,
            ...(getCajasSinContenidos ? {
              marcar_sin_contenidos: marcarSinContenidos ? '1' : '0',
              agrupar_sin_contenidos: agruparSinContenidos,
            } : {}),
          });
        } finally {
          if (countdownIntervalRef.current) {
            clearInterval(countdownIntervalRef.current);
            countdownIntervalRef.current = null;
          }
          setCountdown(null);
          setCountdownTotal(null);
        }
        return;
      }
      // Sin getAllData: fetch paginado con progreso + ExcelJS client-side
      setExportProgress({ current: 0, total: totalPages, startTime: Date.now() });
      let jsonReporte = await obtenerJsonReporte((current, total) => {
        setExportProgress(prev => ({ ...prev, current, total }));
      });
      setExportProgress(null);
      const data_array = jsonReporte.data;
      let jsonReporteFinal = { cuentas: data_array };
      if (!isEmptyObject(data_array)) {
        await exportToExcel(jsonReporteFinal, mergeCells, jsonReporte.sin_jerarquia);
      } else {
        setMessage("No se encontraron registros como para armar un reporte");
        setSeverity("warning");
        setSnackbarVisible(true);
      }
    } catch (err) {
      setMessage(err?.message || "Error al exportar");
      setSeverity("error");
      setSnackbarVisible(true);
    } finally {
      setIsExporting(false);
      setExportProgress(null);
    }
  };

  const validateFields = () => {
    // Obtiene los valores actuales de los campos
    const titleValue = reportTitle.trim();
    const armadoPorValue = armadoPor.trim();

    // Verifica si los campos cumplen con los requisitos
    const isTitleValid = titleValue.length >= 3;
    const isArmadoPorValid = armadoPorValue.length >= 3;

    if (isTitleValid && isArmadoPorValid) {
      return false;
    } else {
      return true;
    }

  };

  // Función para convertir una imagen a base64
  const getBase64FromUrl = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result.split(',')[1]);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  };


  const exportToExcel = async (jsonData, shouldMerge = true, sin_jerarquia = false) => {
    const data1 = [
      {
        "Titulo": reportTitle,
        "Armado_por": armadoPor
      }
    ];

    let data = jsonData;

    const existingFieldMetadato = selectedColumns.indexOf("Metadatos");

    const ordenDeseado = ['Cliente', 'Sector', 'ID caja', 'Referencia/Nro Anterior', 'Tipo de caja(id)', 'Ubicacion', 'Tipo de contenido', 'ID contenido', 'Lote', 'Metadatos'];
    const arrayOrdenado = ordenarArray(selectedColumns, ordenDeseado);

    const columns = arrayOrdenado;
    const dynamicColumns = existingFieldMetadato !== -1 ? sin_jerarquia ? getDynamicColumnsSinJerarquia(data.cuentas) : getDynamicColumns(data.cuentas.cuenta) : [];
    const ordenDeseadoDynamicColumns = ['texto', 'fecha_desde', 'fecha_hasta', 'numero_desde', 'numero_hasta'];
    const dynamicColumnsOrdenados = existingFieldMetadato !== -1 ? ordenarArray(dynamicColumns, ordenDeseadoDynamicColumns) : [];

    // Columnas completas
    const fields = [...columns, ...dynamicColumnsOrdenados];



    // Datos
    const data2 = sin_jerarquia ? flattenJSONSinJerarquia(data.cuentas, fields, reportTitle, armadoPor) : flattenJSON(data.cuentas.cuenta, fields, reportTitle, armadoPor);


    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet('Datos');

    // Convertir la imagen a base64
    const base64Image = await getBase64FromUrl(imagen);
    const imageId = workbook.addImage({
      base64: base64Image,
      extension: 'jpeg', // Cambia esto si tu imagen no es JPEG
    });

    worksheet.addImage(imageId, {
      tl: { col: 0, row: 0 },
      ext: { width: 200, height: 100 } // Ajusta el tamaño según tus necesidades
    });

    // Crear la primera tabla
    const headers1 = ["Titulo", "Armado_por"];
    worksheet.addRow([]); // Espacio para la imagen
    worksheet.addRow([]); // Espacio para la imagen
    worksheet.addRow([]); // Espacio para la imagen
    worksheet.addRow([]); // Espacio para la imagen
    worksheet.addRow([]); // Espacio para la imagen
    worksheet.addRow(headers1);
    data1.forEach(item => {
      worksheet.addRow([
        item.Titulo,
        item.Armado_por
      ]);
    });

    // Aplicar estilo a los encabezados de la primera tabla
    const headerRow1 = worksheet.getRow(7); // Ajusta esto según la posición de tu imagen
    headerRow1.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FF4F4F4F' }, size: 10 }; // gris oscuro, negrita, tamaño 10
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; // gris claro
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Aplicar bordes y ajustar tamaño de fuente a las celdas de la primera tabla
    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      row.eachCell((cell) => {
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        };
        cell.font = { size: 10 }; // tamaño 10
      });
    });

    // Dejar una fila en blanco
    const blankRowNumber = worksheet.lastRow.number + 1;
    worksheet.addRow([]);

    // Crear la segunda tabla
    const headers2 = fields;
    worksheet.addRow(headers2);

    if (shouldMerge) {
      // Columnas a fusionar
      const columnsToMerge = ['Cliente', 'Sector', 'ID caja', 'Referencia/Nro Anterior', 'Tipo de caja(id)', 'Ubicacion', 'Tipo de contenido', 'Lote'];

      // Convertir nombres de columnas a letras
      const columnLetters = columnsToMerge.map(colName => {
        const colIndex = fields.indexOf(colName);
        return colIndex !== -1 ? String.fromCharCode(65 + colIndex) : null;
      }).filter(col => col !== null);

      // Agrupar datos por "ID caja" y "Lote" y unificar celdas
      let startRow = worksheet.lastRow.number + 1;
      let mergeStartRow = startRow;
      let previousIdCaja = null;
      let previousLote = null;

      let mergeEndRow;

      data2.forEach((item, index) => {
        const row = fields.map(field => item[field] || "");
        worksheet.addRow(row);

        const currentRow = startRow + index;
        const idCaja = item['ID caja'];
        const lote = item['Lote'];

        if (idCaja === previousIdCaja && lote === previousLote) {
          // Actualiza el final del rango de fusión
          mergeEndRow = currentRow;
        } else {
          // Si cambia el "ID caja" o "Lote", fusiona el rango previo si es más de una fila
          if (mergeEndRow > mergeStartRow) {
            columnLetters.forEach(col => {
              const mergeRange = `${col}${mergeStartRow}:${col}${mergeEndRow}`;
              worksheet.mergeCells(mergeRange);
              // Centrar el contenido de las celdas fusionadas
              worksheet.getCell(`${col}${mergeStartRow}`).alignment = { vertical: 'middle', horizontal: 'center' };
            });
          }
          // Inicia un nuevo rango de fusión
          mergeStartRow = currentRow;
          mergeEndRow = currentRow;
        }
        previousIdCaja = idCaja;
        previousLote = lote;
      });

      // Fusión final si el último grupo tenía filas repetidas
      if (mergeEndRow > mergeStartRow) {
        columnLetters.forEach(col => {
          const mergeRange = `${col}${mergeStartRow}:${col}${mergeEndRow}`;
          worksheet.mergeCells(mergeRange);
          // Centrar el contenido de las celdas fusionadas
          worksheet.getCell(`${col}${mergeStartRow}`).alignment = { vertical: 'middle', horizontal: 'center' };
        });
      }
    } else {
      // Añadir los datos sin fusionar
      data2.forEach((item) => {
        const row = fields.map(field => item[field] || "");
        worksheet.addRow(row);
      });
    }

    // Aplicar estilo a los encabezados de la segunda tabla
    const headerRow2 = worksheet.getRow(blankRowNumber + 1);
    headerRow2.eachCell((cell) => {
      cell.font = { bold: true, color: { argb: 'FF4F4F4F' }, size: 10 }; // gris oscuro, negrita, tamaño 10
      cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD3D3D3' } }; // gris claro
      cell.alignment = { horizontal: 'center' };
      cell.border = {
        top: { style: 'thin' },
        left: { style: 'thin' },
        bottom: { style: 'thin' },
        right: { style: 'thin' }
      };
    });

    // Aplicar bordes y ajustar tamaño de fuente a las celdas de la segunda tabla
    worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
      if (rowNumber > blankRowNumber + 1) {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: 'thin' },
            left: { style: 'thin' },
            bottom: { style: 'thin' },
            right: { style: 'thin' }
          };
          cell.font = { size: 10 }; // tamaño 10
        });
      }
    });

    // Ajustar el ancho de las columnas
    worksheet.columns.forEach(column => {
      let maxLength = 0;
      column.eachCell({ includeEmpty: true }, cell => {
        maxLength = Math.max(maxLength, (cell.value || '').toString().length);
      });
      column.width = maxLength < 10 ? 10 : maxLength; // Ajusta el ancho mínimo a 10 caracteres
    });

    // Generar el archivo Excel y guardarlo
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    saveAs(blob, `${reportTitle}.xlsx`);
  };



  let columnasTransferList = exportarCajasContenidosColumns ? exportarCajasContenidosColumns : ['ID caja', 'Cliente', 'Sector', 'Referencia/Nro Anterior', 'Tipo de caja(id)', 'Ubicacion', 'Lote', 'Tipo de contenido', 'Metadatos'];

  const handleAnalizar = async () => {
    setAnalisisLoading(true);
    setAnalisisData(null);
    setAnalisisTotales(null);
    setAnalisisError(null);
    try {
      const result = await getCajasSinContenidos(idElementData);
      setAnalisisData(result.cajas || []);
      setAnalisisTotales({
        total: result.total ?? 0,
        conContenidos: result.con_contenidos ?? 0,
        sinContenidos: result.sin_contenidos ?? 0,
      });
    } catch (err) {
      setAnalisisError(err.message || 'Error al analizar');
    } finally {
      setAnalisisLoading(false);
    }
  };

  return (
    <div style={{ textAlign: "center" }}>

      {getCajasSinContenidos && (
        <Tabs
          value={activeTab}
          onChange={(_, v) => setActiveTab(v)}
          sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
        >
          <Tab label="Exportar" />
          <Tab label="Análisis" />
        </Tabs>
      )}

      {/* ── TAB EXPORTAR ── */}
      <Box hidden={getCajasSinContenidos && activeTab !== 0}>
        <FormControl fullWidth size="small" style={{ marginBottom: 20 }}>
          <InputLabel id="id_tipo_archivo">Tipo de Archivo</InputLabel>
          <Select
            labelId="id_tipo_archivo"
            value={fileType}
            label="Tipo de Archivo"
            onChange={(e) => setFileType(e.target.value)}>
            <MenuItem value="CSV">CSV</MenuItem>
            <MenuItem value="JSON">JSON</MenuItem>
            <MenuItem value="Excel">Excel</MenuItem>
          </Select>
        </FormControl>

        {(fileType === 'CSV' || fileType === 'Excel') && (
          <>
            <TransferList
              availableColumns={columnasTransferList}
              selectedColumns={selectedColumns}
              onChange={(columns) => setSelectedColumns(columns)}
            />
            <TextField size="small" style={{ marginTop: 10 }} label="Título del Reporte" fullWidth value={reportTitle} onChange={(e) => setReportTitle(e.target.value)} required />
            <TextField size="small" style={{ marginTop: 10 }} label="Armado Por" fullWidth value={armadoPor} onChange={(e) => setArmadoPor(e.target.value)} required />
          </>
        )}

        {(fileType === 'Excel') && (
          <div>
            <FormControlLabel
              sx={{ fontSize: 4, fontFamily: 'Roboto, sans-serif', color: '#0A395F' }}
              control={
                <Switch
                  checked={mergeCells}
                  onChange={() => setMergeCells(!mergeCells)}
                  color="primary"
                />
              }
              label="Agrupar filas por lote"
            />
            {getCajasSinContenidos && (
              <>
                <FormControlLabel
                  sx={{ fontFamily: 'Roboto, sans-serif', color: '#0A395F', display: 'flex' }}
                  control={
                    <Switch
                      checked={marcarSinContenidos}
                      onChange={() => setMarcarSinContenidos(v => !v)}
                      color="warning"
                    />
                  }
                  label="Marcar cajas sin contenidos"
                />
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 0.5 }}>
                  <FormControlLabel
                    sx={{ fontFamily: 'Roboto, sans-serif', color: '#0A395F', mr: 0 }}
                    control={
                      <Switch
                        checked={agruparSinContenidos !== ''}
                        onChange={(e) => setAgruparSinContenidos(e.target.checked ? 'fin' : '')}
                        color="primary"
                      />
                    }
                    label="Agrupar cajas sin contenidos"
                  />
                  {agruparSinContenidos !== '' && (
                    <FormControl size="small" sx={{ minWidth: 120 }}>
                      <Select
                        value={agruparSinContenidos}
                        onChange={(e) => setAgruparSinContenidos(e.target.value)}
                      >
                        <MenuItem value="inicio">Al inicio</MenuItem>
                        <MenuItem value="fin">Al final</MenuItem>
                      </Select>
                    </FormControl>
                  )}
                </Box>
              </>
            )}
          </div>
        )}

        {isExporting && countdown !== null && countdownTotal !== null && (
          <>
            <LinearProgress
              variant="determinate"
              value={countdownTotal > 0 ? ((countdownTotal - countdown) / countdownTotal) * 100 : 100}
              sx={{ mt: 2, borderRadius: 1 }}
            />
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5, textAlign: 'center' }}>
              {countdown > 0 ? `${countdown}s restantes` : 'Descargando...'}
            </Typography>
          </>
        )}
        {isExporting && countdown === null && exportProgress && exportProgress.total > 0 && (
          <>
            <LinearProgress
              variant="determinate"
              value={exportProgress.total > 0 ? (exportProgress.current / exportProgress.total) * 100 : 0}
              sx={{ mt: 2, borderRadius: 1 }}
            />
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5, textAlign: 'center' }}>
              {`Página ${exportProgress.current} de ${exportProgress.total}`}
              {getEtaText() && ` · ${getEtaText()}`}
            </Typography>
          </>
        )}
        {isExporting && countdown === null && !exportProgress && (
          <>
            <LinearProgress sx={{ mt: 2, borderRadius: 1 }} />
            <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5, textAlign: 'center' }}>
              Generando archivo...
            </Typography>
          </>
        )}

        <Grid sx={{ mt: 1, marginTop: 2 }}>
          <Buttons
            disableButton={isExporting || ((fileType === "CSV" || fileType === "Excel") ? validateFields() : false)}
            onClickSubmit={fileType === "CSV" ? handleDownload : fileType === "Excel" ? handleDownloadExcel : exportToJsonFile}
            labelButtonSave={isExporting ? "Generando..." : "Confirmar"}
            buttonCerrar={props.toggleModal}
          />
        </Grid>
      </Box>

      {/* ── TAB ANÁLISIS ── */}
      {getCajasSinContenidos && activeTab === 1 && (
        <Box sx={{ textAlign: 'left' }}>
          <Alert severity="info" sx={{ mb: 2 }}>
            <Typography variant="body2" sx={{ fontWeight: 600, mb: 0.5 }}>
              ¿Para qué sirve este análisis?
            </Typography>
            <Typography variant="body2">
              Verifica si hay cajas incluidas en el resultado actual que <strong>no tienen contenidos asignados</strong>.
              Esto puede indicar cajas vacías que deberían completarse antes de exportar.
            </Typography>
            <Typography variant="body2" sx={{ mt: 1 }}>
              Al hacer clic en <strong>Analizar</strong>, se consulta la base de datos con los mismos filtros aplicados
              en la búsqueda y se listan las cajas sin contenidos en dos formatos: tabla detallada e IDs agrupados.
            </Typography>
          </Alert>

          <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
            <Button
              variant="contained"
              disabled={analisisLoading}
              onClick={handleAnalizar}
              sx={{ backgroundColor: '#0A395F', '&:hover': { backgroundColor: '#0d4a7a' } }}
            >
              {analisisLoading ? 'Analizando...' : 'Analizar'}
            </Button>
          </Box>

          {analisisLoading && <LinearProgress sx={{ borderRadius: 1, mb: 2 }} />}

          {analisisError && (
            <Alert severity="error" sx={{ mb: 2 }}>{analisisError}</Alert>
          )}

          {analisisData !== null && !analisisLoading && (
            <>
              {analisisTotales && (
                <Box sx={{ display: 'flex', gap: 2, mb: 2, flexWrap: 'wrap' }}>
                  <Paper variant="outlined" sx={{ flex: 1, p: 1.5, textAlign: 'center', minWidth: 100 }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: '#0A395F' }}>{analisisTotales.total}</Typography>
                    <Typography variant="caption" color="text.secondary">Total cajas</Typography>
                  </Paper>
                  <Paper variant="outlined" sx={{ flex: 1, p: 1.5, textAlign: 'center', minWidth: 100, borderColor: 'success.main' }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: 'success.main' }}>{analisisTotales.conContenidos}</Typography>
                    <Typography variant="caption" color="text.secondary">Con contenidos</Typography>
                  </Paper>
                  <Paper variant="outlined" sx={{ flex: 1, p: 1.5, textAlign: 'center', minWidth: 100, borderColor: analisisTotales.sinContenidos > 0 ? 'warning.main' : 'success.main' }}>
                    <Typography variant="h6" sx={{ fontWeight: 700, color: analisisTotales.sinContenidos > 0 ? 'warning.main' : 'success.main' }}>{analisisTotales.sinContenidos}</Typography>
                    <Typography variant="caption" color="text.secondary">Sin contenidos</Typography>
                  </Paper>
                </Box>
              )}
              {analisisData.length === 0 ? (
                <Alert severity="success">
                  Todas las cajas tienen al menos un contenido.
                </Alert>
              ) : (
              <>
                <Alert severity="warning" sx={{ mb: 1 }}>
                  {analisisData.length} {analisisData.length === 1 ? 'caja sin contenido' : 'cajas sin contenido'} encontradas.
                </Alert>

                <TableContainer component={Paper} sx={{ mb: 2, maxHeight: 260 }}>
                  <Table size="small" stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell sx={{ fontWeight: 700, backgroundColor: '#e8edf2' }}>Cliente</TableCell>
                        <TableCell sx={{ fontWeight: 700, backgroundColor: '#e8edf2' }}>Sector</TableCell>
                        <TableCell sx={{ fontWeight: 700, backgroundColor: '#e8edf2' }}>ID Caja</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {analisisData.map((row, i) => (
                        <TableRow key={i} sx={{ '&:nth-of-type(odd)': { backgroundColor: '#f9f9f9' } }}>
                          <TableCell>{row.cliente}</TableCell>
                          <TableCell>{row.sector}</TableCell>
                          <TableCell>{row.id_caja}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>

                <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5, gap: 1 }}>
                  <Typography variant="caption" sx={{ color: '#555', fontWeight: 600 }}>
                    IDs agrupados:
                  </Typography>
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => navigator.clipboard.writeText(analisisData.map(r => r.id_caja).join(', '))}
                    sx={{ fontSize: 11, py: 0, px: 1, minWidth: 0, textTransform: 'none' }}
                  >
                    Copiar
                  </Button>
                </Box>
                <TextField
                  size="small"
                  fullWidth
                  multiline
                  rows={2}
                  value={analisisData.map(r => r.id_caja).join(', ')}
                  InputProps={{ readOnly: true }}
                  sx={{ mb: 1 }}
                />
              </>
              )}
            </>
          )}
        </Box>
      )}

      <SnackbarMessenger
        open={snackbarVisible}
        message={message}
        severity={severity}
        close={() => {
          setSnackbarVisible(false);
        }}
      />
    </div>
  );
};

export default ButtonsExportJsonCSV;



// function eliminarPalabrasDesdeHasta(inputWord) {
//   // Convertir la palabra a minúsculas para una comparación insensible a mayúsculas y minúsculas
//   const lowerCaseWord = inputWord.toLowerCase();

//   // Verificar si la palabra contiene "desde" o "hasta" y eliminarla si es así
//   if (lowerCaseWord.includes('desde') || lowerCaseWord.includes('hasta') || lowerCaseWord.includes('Desde') || lowerCaseWord.includes('Hasta')) {
//     const palabras = inputWord.split(' ');
//     return palabras[0]; // Devuelve solo la primera palabra
//   } else {
//     return inputWord; // Devuelve la palabra original si no contiene "desde" ni "hasta"
//   }
// }

// function verificarMetadatoDesdeHasta(metadato) {
//   // Convertir la palabra a minúsculas para una comparación insensible a mayúsculas y minúsculas
//   const lowerCaseWord = metadato.toLowerCase();

//   // Verificar si la palabra contiene "desde" o "hasta" y eliminarla si es así
//   if (lowerCaseWord.includes('desde') || lowerCaseWord.includes('hasta') || lowerCaseWord.includes('Desde') || lowerCaseWord.includes('Hasta')) {
//     return true;
//   } else {
//     return false;
//   }
// }